export enum SummaryRoutesEnum {
	summary = 'summary',
	storeSelector = 'store-selector',
	shoppingCartStoreSelector = 'shopping-cart-store-selector',
	successMessage = 'success-message',
	shoppingCartSummary = 'shopping-cart-summary',
	contactPersonSelector = 'contact-person-selector',
}
